import EfCompareSpec, { EfCompareSpecProps } from '@elem/ui/ef-compare-spec';
import Bundles from 'elem/compPage/DP3/components/Bundles';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import ChargingMethods from '../teaser/ChargingMethods';
import FooterTips from '../teaser/FooterTips';
import Freedom from '../teaser/Freedom';
import QuietComfort from '../teaser/QuietComfort';
import Recommend from '../teaser/Recommend';
import Smoothly from '../teaser/Smoothly';
import TextListA from '../teaser/TextListA';
// import BarIconR from '../teaser/BarIconR';
import { useLang } from '@/i18n';
import TextA from '../../DP3/teaser/TextA';
import A from '../AUComps/A';
import B from '../AUComps/B';
import B2 from '../AUComps/B2';
import C from '../AUComps/C';
import D from '../AUComps/D';
import E from '../AUComps/E';
import G from '../AUComps/G';
import H from '../AUComps/H';
import UsageScenarios from './UsageScenarios';

import { IPageStatus } from '../components/IPageStatus';
import PageNavLeft from '../components/PageNavLeft';
import { createImgsCallbackPage } from '../components/ThirdLinks';
import { useDP3Store } from '../DP3Provider';
import Banner from './Banner';
import BarIconR from './BarIconR';
import ChargeUpFast from './ChargeUpFast';
import Compare from './Compare';
import ConnectHome from './ConnectHome';
import ConsultingService from './ConsultingService';
import EffortlessApp from './EffortlessApp';
import EnergizeElectricity from './EnergizeElectricity';
import EU1 from './EU1';
import EU10 from './EU10';
import EU11 from './EU11';
import EU12 from './EU12';
import EU2 from './EU2';
import EU3 from './EU3';
import EU4 from './EU4';
import EU5 from './EU5';
import EU6 from './EU6';
import EU7 from './EU7';
import EU8 from './EU8';
import EU9 from './EU9';
import ExploreSecure from './ExploreSecure';
import FAQ from './FAQ';
import MemberB from './MemberB';
import Product2JP from './Product2JP';
import ProductJP from './ProductJP';
import QuietComfortJp from './QuietComfortJp';
import Section1Card from './Section1Card';
import Section1JP from './Section1JP';
import Section2JP from './Section2JP';
import SmoothlyB from './SmoothlyB';
import SwiperJpA from './SwiperJpA';
import SwiperJpB from './SwiperJpB';
import SwiperJpC from './SwiperJpC';
import TabSwriper from './TabSwriper';
import TabSwriper1 from './TabSwriper1';
import TempNA from './TempNA';
import WhatInBox from './WhatInBox';

const TempCommon = () => {
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useDP3Store();
    useEffect(() => {
        if (pageStatus === IPageStatus.statusB) {
            setTimeout(() => {
                // 进入页面,触发第三方埋点
                createImgsCallbackPage();
            }, 1000);
        }
    }, []);
    return (
        <>
            <Banner />
            <div className="g-box">
                <Recommend status="crowdfunding" />
            </div>
            <TextListA />
            <SmoothlyB />
            <MemberB />
            <QuietComfort />
            <div className="white-box">
                <Freedom />
                <div className="dp3-spec"></div>
                <ChargeUpFast />
                <ChargingMethods />
                <div className="dp3-spec"></div>
                <ExploreSecure />
                <div className="dp3-spec"></div>
                <ConnectHome />
                <div className="dp3-spec"></div>
                <EnergizeElectricity />
                <div className="dp3-spec"></div>
                <EffortlessApp />
                <div className="dp3-spec"></div>
                <WhatInBox />
                {locale === 'us' && <ConsultingService />}
                {/* {locale === 'us' && <ExperienceEF />} */}
                <div className="dp3-spec"></div>
            </div>
            <FooterTips />
            {!['us', 'ca', 'br', 'mx'].includes(locale) && <BarIconR />}
        </>
    );
};

const TempJP = ({ jumpForm }: any) => {
    const { t } = useLang('dp3.landing.KSP');
    return (
        <>
            <Banner />

            <div className="white-box">
                <div className="jp-dp3-spec"></div>
                <div className="range1">
                    <TabSwriper />
                </div>
                <div className="jp-dp3-spec"></div>
                <div className="range2">
                    <FAQ />
                </div>
                <div className="jp-dp3-spec"></div>
                <Section1Card />
                <div className="jp-dp3-spec"></div>
                <Section1JP jumpForm={jumpForm} />
                <div className="jp-dp3-spec"></div>
                <TabSwriper1 />
                <div className="jp-dp3-spec"></div>
                <div className="range3">
                    <Section2JP />
                </div>
                <div className="jp-dp3-spec"></div>
                <UsageScenarios />
                <div className="jp-dp3-spec"></div>
                <ProductJP />
                <div className="jp-dp3-spec"></div>
                <Product2JP />
                <div className="jp-dp3-spec"></div>

                <PageNavLeft
                    triggerElement=".dp3-crowdfunding"
                    enterElement="#TabSwriper"
                    steps={[
                        { text: t('item1'), href: '#TabSwriper' },
                        { text: t('item2'), href: '#FAQ' },
                        { text: t('item3'), href: '#Section2JP' },
                    ]}
                />
            </div>

            {/* <TextListA />
            <Smoothly />
            <SwiperJpC />
            <div className="dp3-spec"></div>
            <ExploreSecure />
            <div className="dp3-spec"></div>
            <div className="white-box">
                <div className="dp3-spec"></div>
                <EffortlessApp />
                <SwiperJpA />
                <SwiperJpB />
                <div className="dp3-spec"></div>
                <ChargeUpFast />
                <ChargingMethods />
                <QuietComfortJp />
                <div className="dp3-spec"></div>
                <Compare />
                <div className="dp3-spec"></div>
                <WhatInBox />
                <ConsultingService />
                <div className="dp3-spec"></div>
                <FooterTips />
            </div> */}
        </>
    );
};

const TempEU = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('dp3.landing.Compare');
    const config: EfCompareSpecProps = {
        data: {
            thead: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1728358944417/dp3.png',
                    title: t('O_p1_name'),
                    tag: t('O_new'),
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1728358944245/dp.png',
                    title: t('O_p2_name'),
                },
            ],
            tbody: [
                [
                    {
                        title: t('O_p1_text1'),
                        desc: t('O_prop1'),
                    },
                    {
                        title: t('O_p2_text1'),
                        desc: t('O_prop1'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text2'),
                        desc: t('O_prop2'),
                    },
                    {
                        title: t('O_p2_text2'),
                        desc: t('O_prop2'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text3'),
                        desc: t('O_prop3'),
                    },
                    {
                        title: t('O_p2_text3'),
                        desc: t('O_prop3'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text4'),
                        desc: t('O_prop4'),
                    },
                    {
                        title: t('O_p2_text4'),
                        desc: t('O_prop4'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text5'),
                        desc: t('O_prop5'),
                    },
                    {
                        title: t('O_p2_text5'),
                        desc: t('O_prop5'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text6'),
                        desc: t('O_prop6'),
                    },
                    {
                        title: t('O_p2_text6'),
                        desc: t('O_prop6'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text7'),
                        desc: t('O_prop7'),
                    },
                    {
                        title: t('O_p2_text7'),
                        desc: t('O_prop7'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text8'),
                        desc: t('O_prop8'),
                    },
                    {
                        title: t('O_p2_text8'),
                        desc: t('O_prop8'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text9'),
                        desc: t('O_prop9'),
                    },
                    {
                        title: t('O_p2_text9'),
                        desc: t('O_prop9'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text10'),
                        desc: t('O_prop10'),
                    },
                    {
                        title: t('O_p2_text10'),
                        desc: t('O_prop10'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text11'),
                        desc: t('O_prop11'),
                    },
                    {
                        title: t('O_p2_text11'),
                        desc: t('O_prop11'),
                    },
                ],
                [
                    {
                        title: t('O_p1_text12'),
                        desc: t('O_prop12'),
                    },
                    {
                        title: t('O_p2_text12'),
                        desc: t('O_prop12'),
                    },
                ],
            ],
        },
    };

    return (
        <>
            <Banner />
            <EU1 />
            <TextListA />
            {locale !== 'ph' && <Bundles />}
            <div className="white-box">
                {locale === 'ph' && <EfSpec className="spec-x" />}
                {locale !== 'it' && <EU2 />}
                {locale !== 'it' && <EU3 />}
                <EU4 />
                <Freedom />
                <EU5 />
                <EU6 />
                <EU7 />
                <EU8 />
                {locale === 'it' && <EU2 />}
                {locale === 'it' && <EU3 />}
                <EU9 />
                <EU10 />
                <EfSpec className="spec-x" />
                <div className="compare-info">
                    <p className="title">{t('O_title')}</p>
                    <p className="desc">{t('O_desc')}</p>
                </div>
                <EfCompareSpec {...config} />
                {locale === 'de' && <EU11 />}
                <EfSpec className="spec-x" />
                {locale !== 'ph' && <EU12 />}
            </div>
        </>
    );
};

const TempAU = () => {
    const { pageStatus } = useDP3Store();
    return (
        <>
            <A />
            {['statusA'].includes(pageStatus) && <B />}
            {['statusB'].includes(pageStatus) && <B2 />}
            <TextA needTitle={false} />
            <div className="white-box">
                <TextListA />
            </div>
            <div className="dp3-spec divider-bg"></div>
            <C />
            <div className="dp3-spec"></div>
            <D />
            <div className="dp3-spec"></div>
            <E />
            <QuietComfort hasBottomGap={false} />
            <div className="white-box">
                <div className="dp3-spec divider-bg-2"></div>
                <G />
                <div className="dp3-spec"></div>
                <ChargeUpFast />
                <ChargingMethods />
                <div className="dp3-spec"></div>
            </div>
            <div>
                <div className="dp3-spec"></div>
                <ExploreSecure />
                <div className="dp3-spec"></div>
                <H />
                <div className="dp3-spec"></div>
            </div>
            <div className="white-box">
                <div className="dp3-spec"></div>
                <EffortlessApp />
                <div className="dp3-spec"></div>
                <WhatInBox />
                <div className="dp3-spec"></div>
            </div>
            {/* <FooterTips /> */}
        </>
    );
};

const TempCN = () => {
    return (
        <>
            <Banner />
            <TextListA />
            <Smoothly />
            <SwiperJpC />
            <div className="dp3-spec"></div>
            <ExploreSecure />
            <div className="dp3-spec"></div>
            <EffortlessApp />
            <SwiperJpA />
            <SwiperJpB />
            <div className="dp3-spec"></div>
            <ChargeUpFast />
            <ChargingMethods />
            <QuietComfortJp />
            <Compare />
            <div className="dp3-spec"></div>
            <WhatInBox />
            <div className="dp3-spec"></div>
            <FooterTips />
        </>
    );
};

export default function Teaser({ jumpForm }: any) {
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const IS_NA_SITES = ['us', 'ca'].includes(locale);
    // 日本站点
    if (locale === 'jp') {
        return <TempJP jumpForm={jumpForm} />;
    }
    if (IS_EU_SITES) {
        return <TempEU />;
    }
    if (locale === 'au') {
        return <TempAU />;
    }
    if (locale === 'cn') {
        return <TempCN />;
    }
    if (IS_NA_SITES) {
        return <TempNA />;
    }
    return <TempCommon />;
}
